<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-modal
      :no-close-on-backdrop="true"
      id="modal-edit"
      ok-only
      centered
      size="lg"
      :title="
        createMode ? $t('lab.add-test-report') : $t('lab.edit-test-report')
      "
    >
      <b-card-text>
        <b-row>
          <b-col md="4">
            <b-form-group
              :label="$t('lab.test-report')"
              label-for="test_report"
            >
              <b-form-input
                v-model="EditForm.name"
                :placeholder="$t('lab.test-report')"
              />
              <p class="text-danger mt-1">{{ errorForm.name }}</p>
            </b-form-group>
          </b-col>
          <b-col md="">
            <AutoComplete
              :label="$t('lab.test_name')"
              :placeholder="$t('lab.test_name')"
              v-model="EditForm.test_id"
              :serializer="(val) => val.id"
              param-query="id"
              endpoint="test"
              text-title="name"
              style="flex: 1"
            />
            <p class="text-danger mt-1">{{ errorForm.test_id }}</p>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitItem"
          class="m-0"
          :disabled="loading"
          ref="button"
          block
        >
          <span v-if="!loading">{{
            createMode ? $t("common.add") : $t("common.edit")
          }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>

    <b-card :title="$t('lab.filter-test-report')">
      <div>
        <!-- Search Form -->
        <b-row class="mt-3">
          <b-col md="6" cols="12">
           
            <AutoComplete
              :label="$t('lab.test_report_name')"
              :placeholder="$t('lab.test_report_name')"
              v-model="testReportName"
              :serializer="(val) => val.name"
              param-query="filter[id]=-id"
              endpoint="testReport"
              text-title="name"
              style="flex: 1"
            />
          </b-col>
          <b-col md="6" cols="12">
            <b-form-group :label="$t('lab.test_name')" label-for="abo">
              <AutoComplete
                :placeholder="$t('lab.test_name')"
                v-model="testId"
                :serializer="(val) => val.id"
                param-query="id"
                endpoint="test"
                text-title="name"
                style="flex: 1"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-2 mb-3">
            <b-col md="12" cols="12">
            <b-form-group
              :label="$t('common.created-at')"
              label-for="production_date"
            >
              <datepicker
                v-model="from_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getBloodBottles()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
            <!-- <b-button variant="primary" v-print="IVF" class="mx-2">
                            {{ $t("surgery.Print-Hospital-Expenses") }}
                        </b-button> -->
          </b-col>
        </b-row>

        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("lab.test-report-table") }}</h2>
          <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t("lab.add-test-report") }}
          </b-button>
        </div>

        <b-table
          :items="data"
          responsive
          :fields="bloodBottleTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found"
          class="position-relative"
          v-if="!loading"
        >
          <template #cell(test_name)="data">
            {{ data.item.test.name }}
          </template>
          <template #cell(test_price)="data">
            {{ data.item.test.price }}
          </template>
          <template #cell(test_report_fields)="data">
            <ol>
              <li v-for="field in data.item.test_report_fields" :key="field.id">
                <b-badge variant="primary" style="margin-bottom: 5px">{{
                  field.name
                }}</b-badge>
              </li>
            </ol>
          </template>
          <template #cell(add_test_report_fields)="data">
            <b-button
              size="sm"
              pill
              variant="outline-primary"
              @click="
                $router.push({
                  name: 'test-report-fields',
                  params: {
                    test_report_id: data.item.id,
                    test_report_name: data.item.name,
                    test_id: data.item.test_id,
                    test_name: data.item.test.name,
                  },
                })
              "
            >
              {{ $t("lab.show-fields") }}
            </b-button>
          </template>

          <template #cell(add_patient_to_test)="data">
            <b-button
              size="sm"
              pill
              variant="outline-primary"
              @click="
                $router.push({
                  name: 'add-patient-to-test',
                  params: {
                    test_report_id: data.item.id,
                    test_report_name: data.item.name,
                    test_id: data.item.test_id,
                    test_name: data.item.test.name,
                  },
                })
              "
            >
              {{ $t("lab.add-patient-to-test") }}
            </b-button>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="update-patient"
                editPerm="update-patient"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getBloodBottles()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <IVF :data="data" type="Hospital" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import Datepicker from "vuejs-datepicker";
const IVF = () => import("@/components/printables/IVF.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import AutoComplete from "@/components/common/AutoComplete.vue";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
    AutoComplete,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        name: "",
        test_id: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        name: "",
        test_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      bloodBottleTableColumns: [
        {
          key: "name",
          sortable: true,
          label: this.$t("lab.test-report"),
        },
        {
          key: "test_name",
          sortable: true,
          label: this.$t("lab.test-name"),
        },
        {
          key: "test_price",
          sortable: true,
          label: this.$t("lab.test-price"),
        },
        {
          key: "test_report_fields",
          sortable: true,
          label: this.$t("lab.test-report-fields"),
        },
        {
          key: "add_test_report_fields",
          sortable: true,
          label: this.$t("lab.add-test-report-fields"),
        },

        {
          key: "add_patient_to_test",
          sortable: true,
          label: this.$t("lab.add-patient-to-test"),
        },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },

        {
          key: "Actions",
          label: this.$t("common.actions"),
          thStyle: { width: "150px" },
        },
      ],

      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      IVF: {
        id: "IVF",
      },

      testReportName: "",
      testId: "",
     
      searchDate: "",
      selectedSearch: "",
      from_date: "",
      to_date: "",
    };
  },
  mounted() {
    this.getBloodBottles();
  },
  watch: {
    searchDate(newVal) {
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.name = item.name;
        this.EditForm.test_id = item.test_id;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getBloodBottles() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/testReport?page=${this.page}&take=${
        this.searchDate && (this.from_date || this.to_date) ? 1000 : 15
      }&sort=-id&include[]=test&include[]=testReportFields&include[]=testReportResults`;

      if (this.testReportName) {
        url += `&filter[name]=${this.testReportName}`;
      }
      if (this.testId) {
        url += `&filter[test_id]=${this.testId}`;
      }
      if (this.from_date) {
        url += `&filter[created_at]=${this.formatDate(
          this.from_date
        )}`;
      }
     

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/testReport/${this.deleteForm.id}`)
        .then((response) => {
          this.getBloodBottles();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text:
                "deleted " + this.deleteForm.testReportName + " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.bottle_identifier,
            },
          });
        });
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.name = "";
      this.errorForm.test_id = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.name) {
        count++;
        this.errorForm.name = "The name field is required.";
      }
      if (!this.EditForm.test_id) {
        count++;
        this.errorForm.test_id = "The test id field is required.";
      }

      console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/testReport`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              console.log("this.expenses", this.expenses);
              this.getBloodBottles();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/testReport/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              this.getBloodBottles();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
